import type { InterventionsListBreadcrumbProps } from "./interventions-list-breadcrumb.type";
import type { BreadcrumbItem } from "@/modules/breadcrumb";

import Breadcrumb from "@/modules/breadcrumb";

const InterventionsListBreadcrumb = ({
  interventions,
}: InterventionsListBreadcrumbProps) => {
  const items: BreadcrumbItem[] = interventions.map(({ id }) => ({
    title: `${id}`,
    href: `/interventions/${id}`,
    model: "intervention",
  }));

  return <Breadcrumb items={items} />;
};

export default InterventionsListBreadcrumb;
